<div
  class="fixed inset-0 z-50 flex items-center justify-center bg-flap-black/60 px-4"
  (click)="cancel()"
  (keydown.escape)="cancel()"
>
  <div
    role="dialog"
    aria-modal="true"
    aria-labelledby="delete-account-title"
    class="w-full max-w-md bg-white rounded-xl shadow-lg p-8 space-y-5"
    (click)="$event.stopPropagation()"
  >
    <div>
      <h2 id="delete-account-title" class="text-2xl font-bold text-flap-black mb-2">Delete account</h2>
      <p class="text-rail-gray text-sm">
        This action cannot be undone. This will permanently delete your account and all associated data, including:
      </p>
      <ul class="mt-3 space-y-1 text-sm text-rail-gray list-disc list-inside">
        <li>Your profile and login credentials</li>
        <li>All boards you have created</li>
        <li>All messages on those boards</li>
      </ul>
    </div>

    <div class="bg-signal-orange/10 border-2 border-signal-orange rounded-lg p-4 text-sm text-flap-black">
      <strong>Warning:</strong> once you delete your account, there is no going back. Nothing is archived
      or recoverable. Please be certain.
    </div>

    <label class="flex items-start gap-3 cursor-pointer">
      <input
        type="checkbox"
        [ngModel]="understood()"
        (ngModelChange)="understood.set($event)"
        name="understood"
        class="mt-1 w-4 h-4 accent-signal-orange"
      />
      <span class="text-sm text-flap-black">
        I understand that this action cannot be undone and all my data will be permanently deleted.
      </span>
    </label>

    @if (requirePassword()) {
      <div>
        <label for="delete-password" class="block text-sm font-semibold text-flap-black mb-1">
          Confirm your password
        </label>
        <input
          id="delete-password"
          type="password"
          autocomplete="current-password"
          [ngModel]="password()"
          (ngModelChange)="password.set($event)"
          name="deletePassword"
          class="w-full px-4 py-3 rounded-lg border-2 border-border-subtle focus:border-signal-orange outline-none transition-colors"
        />
      </div>
    }

    @if (error(); as err) {
      <p class="text-sm text-signal-orange">{{ err }}</p>
    }

    <div class="flex justify-end gap-3 pt-2">
      <button
        type="button"
        (click)="cancel()"
        [disabled]="busy()"
        class="px-4 py-2 border-2 border-border-subtle text-rail-gray rounded-lg font-semibold hover:bg-bg-secondary transition-colors disabled:opacity-60 cursor-pointer"
      >
        Cancel
      </button>
      <button
        type="button"
        (click)="confirm()"
        [disabled]="!canDelete()"
        class="px-4 py-2 bg-signal-orange text-white rounded-lg font-semibold hover:bg-signal-orange/90 transition-colors disabled:opacity-60 disabled:cursor-not-allowed cursor-pointer"
      >
        {{ busy() ? 'Deleting…' : 'Delete Forever' }}
      </button>
    </div>
  </div>
</div>
